<h1 mat-dialog-title>{{TitleText}}</h1>
<div mat-dialog-content>
    <p [innerHtml]="MessageText"></p>
    <mat-form-field style="width: 100%;">
        <mat-select [(ngModel)]="Denial.DenialType" placeholder="Select reason" aria-label="Reason Select List">
            <mat-option *ngFor="let dtype of DenialTypes" [value]="dtype">{{dtype.Description}}</mat-option>
        </mat-select>
    </mat-form-field>
    
    <mat-form-field style="width: 100%;" *ngIf="Denial.DenialType != null && Denial.DenialType.RequiresNote === true">
        <input matInput type="text" [(ngModel)]="Denial.DenialNote"
            [disabled]="Denial.DenialType == null || Denial.DenialType.RequiresNote !== true"
            [required]="Denial.DenialType != null && Denial.DenialType.RequiresNote === true"
            placeholder="Enter reason..." />
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="warn" (click)="CancelHandler()">{{CancelText}}</button>
    <button mat-raised-button color="primary" (click)="OKHandler()"
        [disabled]="Denial.DenialType == null || (Denial.DenialType != null && Denial.DenialType.RequiresNote === true && (Denial.DenialNote == null || Denial.DenialNote == ''))">{{OKText}}</button>
</div>